import { useState } from "react";
import { supabase } from "../supabaseClient";

const categoryOptions = [
  "Outdoor",
  "Arts",
  "Recreation",
  "Education",
  "Wellness",
  "Sports",
];

export default function AddActivity() {
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    location: "",
    address: "",
    age_group: "",
    cost: "",
    schedule: "",
    website: "",
    maps_link: "",
    accessibility: "",
    description: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
  });

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    setMessage("");
    setMessageType("");
    setLoading(true);

    const payload = {
      ...formData,
      is_active: true,
      approved: false,
    };

    const { error } = await supabase.from("activities").insert([payload]);

    setLoading(false);

    if (error) {
      console.error(error);
      setMessage("There was an error saving the activity.");
      setMessageType("error");
      return;
    }

    setMessage("Activity added successfully. It is pending approval.");
    setMessageType("success");

    setFormData({
      name: "",
      category: "",
      location: "",
      address: "",
      age_group: "",
      cost: "",
      schedule: "",
      website: "",
      maps_link: "",
      accessibility: "",
      description: "",
      contact_name: "",
      contact_email: "",
      contact_phone: "",
    });
  }

  return (
    <section className="container">
      <div className="activity-card">
        <div className="page-header">
          <h1>Add Activity</h1>
          <p>
            Add a community activity, event, or program that may benefit
            individuals and families.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="activity-form">
          <div className="form-section">
            <h2>Basic Information</h2>

            <div className="form-grid">
              <div className="field full-width">
                <label>Activity Name</label>
                <input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Ex: Community Art Class"
                />
              </div>

              <div className="field">
                <label>Category</label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select</option>
                  {categoryOptions.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
              </div>

              <div className="field">
                <label>County / Location</label>
                <input
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  placeholder="Ex: Westchester County"
                />
              </div>

              <div className="field full-width">
                <label>Address</label>
                <input
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  placeholder="Street address or venue name"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>Program Details</h2>

            <div className="form-grid">
              <div className="field">
                <label>Age Group</label>
                <input
                  name="age_group"
                  value={formData.age_group}
                  onChange={handleChange}
                  placeholder="Children, Teens, Adults"
                />
              </div>

              <div className="field">
                <label>Cost</label>
                <input
                  name="cost"
                  value={formData.cost}
                  onChange={handleChange}
                  placeholder="Free, $10, etc."
                />
              </div>

              <div className="field full-width">
                <label>Schedule</label>
                <input
                  name="schedule"
                  value={formData.schedule}
                  onChange={handleChange}
                  placeholder="Weekly, Saturdays, Monthly, etc."
                />
              </div>

              <div className="field full-width">
                <label>Accessibility Notes</label>
                <input
                  name="accessibility"
                  value={formData.accessibility}
                  onChange={handleChange}
                  placeholder="Wheelchair accessible, sensory-friendly, support person welcome"
                />
              </div>

              <div className="field full-width">
                <label>Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Brief description of the activity"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>Links</h2>

            <div className="form-grid">
              <div className="field">
                <label>Website Link</label>
                <input
                  name="website"
                  value={formData.website}
                  onChange={handleChange}
                  placeholder="https://..."
                />
              </div>

              <div className="field">
                <label>Google Maps Link</label>
                <input
                  name="maps_link"
                  value={formData.maps_link}
                  onChange={handleChange}
                  placeholder="https://maps.google.com/..."
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>Contact Information</h2>

            <div className="form-grid">
              <div className="field">
                <label>Contact Name</label>
                <input
                  name="contact_name"
                  value={formData.contact_name}
                  onChange={handleChange}
                  placeholder="Ex: Program Coordinator"
                />
              </div>

              <div className="field">
                <label>Contact Email</label>
                <input
                  type="email"
                  name="contact_email"
                  value={formData.contact_email}
                  onChange={handleChange}
                  placeholder="contact@example.com"
                />
              </div>

              <div className="field full-width">
                <label>Contact Phone</label>
                <input
                  name="contact_phone"
                  value={formData.contact_phone}
                  onChange={handleChange}
                  placeholder="(555) 123-4567"
                />
              </div>
            </div>
          </div>

          {message && (
            <div className={`form-message ${messageType}`}>
              {message}
            </div>
          )}

          <div className="button-row">
            <button type="submit" disabled={loading} className="save-button">
              {loading ? "Saving..." : "Add Activity"}
            </button>
          </div>
        </form>
      </div>

      <style>{`
        .activity-card {
          background: white;
          border-radius: 20px;
          padding: 40px;
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
        }

        .page-header {
          text-align: center;
          margin-bottom: 32px;
        }

        .page-header h1 {
          margin: 0 0 10px 0;
          font-size: 2rem;
          color: #1f2937;
        }

        .page-header p {
          margin: 0;
          color: #6b7280;
          font-size: 1.05rem;
          line-height: 1.7;
        }

        .activity-form {
          display: flex;
          flex-direction: column;
          gap: 26px;
        }

        .form-section {
          background: #f9fbfd;
          border: 1px solid #dbe1ea;
          border-radius: 18px;
          padding: 24px;
        }

        .form-section h2 {
          margin: 0 0 18px 0;
          font-size: 1.2rem;
          color: #2f6f89;
        }

        .form-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 18px;
        }

        .field {
          display: flex;
          flex-direction: column;
        }

        .full-width {
          grid-column: 1 / -1;
        }

        .field label {
          font-weight: 600;
          margin-bottom: 8px;
          color: #1f2937;
        }

        .field input,
        .field select,
        .field textarea {
          width: 100%;
          padding: 13px 14px;
          border-radius: 10px;
          border: 1px solid #dbe1ea;
          font-size: 1rem;
          background: white;
          box-sizing: border-box;
        }

        .field textarea {
          min-height: 120px;
          resize: vertical;
        }

        .form-message {
          padding: 14px 16px;
          border-radius: 12px;
          font-weight: 500;
        }

        .form-message.success {
          background: #f4f9fc;
          border: 1px solid #d8ebf3;
          color: #2f6f89;
        }

        .form-message.error {
          background: #fff3f3;
          border: 1px solid #f0c2c2;
          color: #a33a3a;
        }

        .button-row {
          display: flex;
          justify-content: flex-end;
        }

        .save-button {
          background: #2f6f89;
          color: white;
          border: none;
          padding: 14px 22px;
          border-radius: 12px;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
        }

        .save-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        @media (max-width: 900px) {
          .activity-card {
            padding: 24px;
          }

          .form-grid {
            grid-template-columns: 1fr;
          }

          .save-button {
            width: 100%;
          }
        }
      `}</style>
    </section>
  );
}